module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/search/search-section/search-section.style.scss
// module id = 822
// module chunks = 2